<template>
  <div id="offer" v-if="tileList">
    <v-container>
      <v-row>
        <v-col>
          <div :style="headerStyle" class="mt-4 mb-2">
            <span class="tx-1 tx-b-700 tx-dark-gray tx-mt-0">
              Zapoznaj się z ofertą!
            </span>
          </div>
        </v-col>
      </v-row>
      <v-row dense v-if="tileList">
        <v-col
          v-for="(tile, i) in tileList"
          :key="i"
          :cols="getTileWidth(tile)"
          :class="getTileContainerStyleClass(tile)"
        >
          <div :class="getTileStyleClass(tile)">
            <div class="tile__image tile__image--blurred">
              <v-img
                :style="
                  tile.large
                    ? 'padding-bottom: calc(50% - 4px);'
                    : 'padding-bottom: 100%;'
                "
                height="0"
                width="100%"
                :src="
                  tile.image
                    ? '/images/thumbnail-' +
                      tile.image.name
                    : ''
                "
              ></v-img>
              <div class="image__dark-filter"></div>
              <div class="image__short">
                <div class="short__text">{{ tile.short }}</div>
              </div>
            </div>
            <v-btn
              class="v-btn--inside-tile"
              @click="navigateToOfferElement(tile)"
              depressed
              block
              tile
            >
              <div class="content__label-elements">
                <div :class="tileIconStyleClass" v-if="tile.icon">
                  <font-awesome-icon
                    :icon="[tile.icon.prefix, tile.icon.name]"
                  />
                </div>
                <div :class="tileTitleStyleClass">
                  {{ tile.title }}
                </div>
              </div>
            </v-btn>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { $axios } from "@/axios";
import { FasIcon } from "@/models/fas-icon.model";
import { OfferElementTile } from "@/models/offer-element-tile.model";
import { backendUrl } from "@/backend";
import websiteContents from "@/website-contents";

export default {
  name: "offer-tiles-component",
  data: function() {
    return {
      showDialog: null,
      tileList: null,

      backendUrl: backendUrl
    };
  },
  mounted() {
    this.getTileList();
  },
  props: ["colsTakenByTile"],
  computed: {
    loggedIn: function() {
      return this.$store.state.authentication.loggedIn;
    },
    headerStyle: function() {
      return this.loggedIn ? "display: flex; align-items: center;" : "";
    },
    tileIconStyleClass: function() {
      const base = "label-elements__icon";
      return base + ` ${base}-${this.$vuetify.breakpoint.name}`;
    },
    tileTitleStyleClass: function() {
      const base = "label-elements__title";
      return base + ` ${base}-${this.$vuetify.breakpoint.name}`;
    }
  },
  methods: {
    getTileList() {
      this.tileList = new Array(OfferElementTile);
      this.tileList = this.sortedTileListByIndex(websiteContents.offerElements);
      this.parseIconNamesForFas();
      this.$emit("loading-finished");
    },
    parseIconNamesForFas() {
      this.tileList.forEach(tile => {
        tile.icon = new FasIcon(tile.iconName);
      });
    },
    sortedTileListByIndex(tileList) {
      return tileList.sort((offerElementA, offerElementB) =>
        offerElementA.index > offerElementB.index ? 1 : -1
      );
    },
    navigateToOfferElement(tile) {
      const path = `/oferta/${tile.title
        .toString()
        .toLowerCase()
        .replaceAll(" ", "-")}`;
      this.$router.push(path);
    },
    getTileStyleClass(tile) {
      let styleClass =
        tile.large === true || tile.large === 1 ? "tile-2x1" : "tile-1x1";
      return (styleClass +=
        tile.highlighted === true || tile.highlighted === 1
          ? ` ${styleClass}--highlighted`
          : "");
    },
    getTileWidth(tile) {
      return this.colsTakenByTile * (tile.large ? 2 : 1);
    },
    getTileContainerStyleClass(tile) {
      return tile.visible ? "" : "d-none";
    }
  }
};
</script>

<style lang="scss">
.v-btn--inside-tile {
  .v-btn__content {
    width: 100%;
  }
}
</style>

<style lang="scss" scoped>
@import "@/global-scss/style-classes";

.tile-1x1,
.tile-2x1 {
  position: relative;
  top: 0;
}

.tile-1x1--highlighted,
.tile-2x1--highlighted {
  .v-btn--inside-tile {
    background-color: $brand-color !important;
  }

  * {
    color: white;
  }
}

.tile__image {
  background-color: $brand-color;
  position: relative;
  top: 0;
  width: 100%;
}

.image__dark-filter {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  background-color: rgb(0, 0, 0, 0.5);
}

.image__short {
  width: 100%;
  height: 100%;
  padding: 24px;
  position: absolute;
  top: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}

.short__text {
  max-height: 100%;
  max-width: 100%;
  text-align: center;
  font-size: 16px;
  color: white;
  overflow: hidden;
  text-overflow: ellipsis;
}

.v-btn--inside-tile {
  position: absolute;
  top: 0;
  height: 100% !important;
  width: 100% !important;
  font-weight: 500;
  white-space: initial;
  text-transform: initial;
  letter-spacing: initial;
  color: #707070;
}

.v-btn--inside-tile:hover {
  opacity: 0;
}

.content__label-elements {
  display: flex;
  flex-direction: column;
}

.label-elements__title {
  margin-top: 12px;
  font-size: 16px;
}

.label-elements__icon {
  font-size: 36px;
}
</style>
<style lang="scss">
.tile__image--blurred .v-image__image {
  filter: blur(2px);
}
</style>
